import EggProductionContainer from "./EggProductionWidgetContainer";
export type { EggProductionApiResponse } from "./EggProduction";

export default EggProductionContainer;
